import { FORM_ERROR } from 'final-form';
import React, { Fragment, useContext } from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import { Link } from 'react-router-dom';
import { combineValidators, isRequired } from 'revalidate';
import {
  Button,
  Container,
  Form,
  Header,
  Image,
  Segment,
  Grid,
} from 'semantic-ui-react';

import ErrorMessage from '../../app/common/form/ErrorMessage';
import TextInput from '../../app/common/form/TextInput';
import { IClerkFormValues } from '../../app/models/clerk';
import { RootStoreContext } from '../../app/stores/rootStore';

const validate = combineValidators({
  clerkNumber: isRequired({ message: '担当者番号は必須入力です' }),
  clerkPassword: isRequired({ message: 'パスワードは必須入力です' }),
});

const SignInPage = () => {
  const token = window.localStorage.getItem('jwt');
  const rootStore = useContext(RootStoreContext);
  const { isSignIn, clerk, signin } = rootStore.clerkStore;

  return (
    <Segment inverted vertical className='masthead'>
      <Container>
        <Grid textAlign='center'>
          <Grid.Column width={5}>
            <Header as='h1' inverted>
              <Image
                src='/assets/logo.png'
                alt='logo'
                style={{ marginBottom: 12 }}
              />
              東京タワー 預託
            </Header>
            {isSignIn && clerk && token ? (
              <Fragment>
                <Button
                  as={Link}
                  to='/admin/depositsales'
                  size='medium'
                  inverted
                >
                  預託チケット一覧
                </Button>
              </Fragment>
            ) : (
              <Fragment>
                <FinalForm
                  onSubmit={(values: IClerkFormValues) =>
                    signin(values).catch((error) => ({
                      [FORM_ERROR]: error,
                    }))
                  }
                  validate={validate}
                  render={({
                    handleSubmit,
                    submitError,
                    invalid,
                    pristine,
                    dirtySinceLastSubmit,
                  }) => (
                    <Form onSubmit={handleSubmit} error>
                      <Field
                        name='clerkNumber'
                        component={TextInput}
                        placeholder='担当者番号'
                      />
                      <Field
                        name='clerkPassword'
                        component={TextInput}
                        placeholder='パスワード'
                        type='password'
                      />
                      {submitError && !dirtySinceLastSubmit && (
                        <ErrorMessage
                          error={submitError}
                          text='担当者番号またはパスワードが正しくありません。'
                        />
                      )}
                      <Button
                        disabled={
                          (invalid && !dirtySinceLastSubmit) || pristine
                        }
                        color='teal'
                        content='Login'
                        fluid
                      />
                    </Form>
                  )}
                />
              </Fragment>
            )}
          </Grid.Column>
        </Grid>
      </Container>
    </Segment>
  );
};

export default SignInPage;
